import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=c61d2ea6&scoped=true"
import script from "./Home1.vue?vue&type=script&lang=js"
export * from "./Home1.vue?vue&type=script&lang=js"
import style0 from "./Home1.vue?vue&type=style&index=0&id=c61d2ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61d2ea6",
  null
  
)

export default component.exports